import React from 'react'
import Link from 'gatsby-link'

import { logo } from '../images'

const Header = ({ siteTitle }) => (
  <div>
    <h1>Header component</h1>
    <img src={ logo } style={{ width: 320 }} />
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js